<script setup lang="ts">
useHomeSeo();
</script>
<template>
  <SectionsHeader />
  <SectionsJourney />
  <SectionsReelsCarousel />
  <SectionsConquer />
  <UtilsSeparator position="left" />
  <SectionsTestimonials />
  <UtilsSeparator position="left" />
  <SectionsAuthor />
  <SectionsVideo />
  <SectionsStoreHighlight />
  <SectionsBuyOptions />
  <SectionsBuyNow />
  <SectionsSubscribeForm />
  <UtilsSeparator position="right" />
  <SectionsFaq />
  <UtilsColoredSeparator />
  <SectionsInstagram />
  <SectionsFooter />
  <UtilsScrollup />
</template>
